/* eslint-disable react/prop-types */
import React from 'react';
import { useSelector } from 'react-redux';
import UsersContainerHeader from '@/views/pages/Users/elements/UsersContainerHeader';
import UsersItem from '@/views/pages/Users/elements/UsersItem';
import Spinner from '@/views/components/Spinner/Spinner';

const UsersContainer = ({ 
	userData, 
	isLoading, 
	onEditItem,
	onDeleteItem,
	setShowModalDeleteItem,
	setShowModalAddDepartment,
}) => {
	const { dict } = useSelector((state) => state.app);

	return (
		<section className='table__container'>
			<UsersContainerHeader />
			{ userData && !isLoading && userData.map((item) => {
				return (
					<UsersItem
						key={ item.id }
						data={ item }
						onEditItem={ onEditItem }
						onDeleteItem={ onDeleteItem }
						setShowModalDeleteItem={ setShowModalDeleteItem }
						setShowModalAddDepartment={ setShowModalAddDepartment }
					/>
				);

			})}
			{ (!userData || isLoading) && (
				<Spinner addClass='table__spinner' />
			)}
			{ userData && userData.length === 0 && (
				<div className='table__no-elements'>
					{ dict.users.list.noElements}
				</div>
			)}
		</section>
	);
};
export default UsersContainer;